import React from "react";
import Lottie from "lottie-react";
import animationData from "./Refresh_Lottie.json";
import "./Refresh_Lottie.css";

function Refresh_Lottie() {
  if (!animationData) return null;

  return (
    <section className="main">
      <div className="Refresh_Lottie">
        <Lottie
          animationData={animationData}
          loop={true}
          autoplay={true}
          className="me-auto"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </section>
  );
}

export default Refresh_Lottie;
